import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useDashboard = () =>
  useQuery({ queryKey: ["dashboard"], queryFn: async () => (await axios.get(`${API}/dashboard`)).data });

export const useRefresh = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["dashboard"] });
};

export const patchProduct = (code, body) => axios.patch(`${API}/products/${encodeURIComponent(code)}`, body);
export const createProduct = (body) => axios.post(`${API}/products`, body);
export const deleteProduct = (code) => axios.delete(`${API}/products/${encodeURIComponent(code)}`);
export const patchEntry = (key, body) => axios.patch(`${API}/report/${encodeURIComponent(key)}`, body);
export const patchSettings = (body) => axios.patch(`${API}/settings`, body);
export const errMsg = (e) => e?.response?.data?.detail?.toString?.() || e.message;
